'use client'

import { type AxiosError } from 'axios'
import useSwr, { type SWRResponse } from 'swr'

import {
  MiraklControllerV2ApiFactory,
  type MiraklMessagingOrderInfoV2,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

const SWR_KEY = 'miraklMessagingOrderInfo'

const getSwrKey = (subOrderId: string): string => {
  return `${SWR_KEY}_${subOrderId}`
}

export const useApiOrdersSwrGetMiraklMessagingOrderInfo = (options: {
  enabled?: boolean
  subOrderId?: string
}): SWRResponse<MiraklMessagingOrderInfoV2, AxiosError> => {
  const client = useGlooApi(MiraklControllerV2ApiFactory)
  const config = useGlobalConfigContext()
  const { enabled = true, subOrderId } = options

  const shouldFetch = enabled && Boolean(subOrderId)

  const fetcher = async (): Promise<MiraklMessagingOrderInfoV2> => {
    const response = await client.miraklV2TenantSubOrderidGet({
      subOrderid: subOrderId ?? '',
      tenant: config.tenantAndEnv,
    })

    return response.data
  }

  return useSwr(shouldFetch ? getSwrKey(subOrderId ?? '') : null, fetcher)
}
